import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { IS_PRODUCTION } from '@rma/public/generic/util/environment';
import { installTrackJS } from '@rma/public/generic/util/tracking/track-js';
import { RmaLayoutComponent } from '@rma/public/site/public/orc-layout';
import { RecaptchaComponent } from 'ng-recaptcha';
import { config } from './app/app.config.browser';

if (IS_PRODUCTION) {
  enableProdMode();
  installTrackJS('public-ui');
}

// Bootstrap synchronously so incremental hydration + event replay can take
// over the SSR-rendered DOM as early as possible. Wrapping in
// DOMContentLoaded + setTimeout previously delayed hydration past first
// interaction, hurting INP and prolonging the "events being captured" window.
bootstrapApplication(RmaLayoutComponent, config).catch((err) => console.error(err));

RecaptchaComponent.prototype.ngOnDestroy = function () {
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
};
